"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = __importDefault(require("../../../../Utils"));
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/files`;
    }
    /**
     * Posts a file.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/files
     * Rate Limit Group: Heavy
     * App Permission: TeamMessaging
     */
    async post(createGlipFileNewRequest, queryParams, restRequestConfig) {
        const formData = await Utils_1.default.getFormData(createGlipFileNewRequest);
        const r = await this.rc.post(this.path(), formData, queryParams, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map